/* BRELO theme: one file, no dependencies. Every behaviour hooks onto data-attributes that the sections render. */
(function () {
  "use strict";
  var B = window.BRELO || {}, T = B.t || {}, S = B.settings || {};
  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var PHONE = window.matchMedia("(max-width: 860px)").matches;
  var MONTHS = String(T.months || "").split(",").map(function (s) { return s.trim(); });
  var KA = (B.locale || "ka").indexOf("ka") === 0;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function load(k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  /* ---------- money, in the shop's own format ---------- */
  function money(cents) {
    var fmt = B.money || "{{amount}} ₾", n = (cents || 0) / 100;
    function grp(x, dec, ts, ds) {
      var p = x.toFixed(dec).split("."), i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return i + (p[1] ? ds + p[1] : "");
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === "amount_no_decimals") return grp(n, 0, ",", ".");
      if (k === "amount_with_comma_separator") return grp(n, 2, ".", ",");
      if (k === "amount_no_decimals_with_comma_separator") return grp(n, 0, ".", ",");
      if (k === "amount_with_space_separator") return grp(n, 2, " ", ",");
      return grp(n, 2, ",", ".");
    });
  }
  function fmtDate(d) { return KA ? d.getDate() + " " + (MONTHS[d.getMonth()] || "") : (MONTHS[d.getMonth()] || "") + " " + d.getDate(); }
  function addDays(n) { var x = new Date(); x.setDate(x.getDate() + n); return x; }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    var el = $(".toast"); if (!el || !msg) return;
    el.textContent = msg; el.classList.add("is-on");
    clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove("is-on"); }, 2200);
  }

  /* ---------- drawers, menu, search ---------- */
  var lastFocus;
  function lock(on) { document.body.classList.toggle("is-locked", on); }
  function openDrawer(el) {
    if (typeof el === "string") el = $(el);
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add("is-open"); lock(true);
    var f = $("[data-close]:not(.drawer__veil):not(.mega__veil)", el);
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }
  function closeAll() {
    var wo = $(".wo.is-open"); if (wo && wo._close) { wo._close(); }
    $$(".drawer.is-open, .mega.is-open, .modal.is-open, .lb.is-open, .search.is-open").forEach(function (d) { d.classList.remove("is-open"); });
    lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener("click", function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    if (t.closest("[data-close]") || t.closest("[data-close-search]")) { e.preventDefault(); closeAll(); return; }
    var oc = t.closest("[data-open-cart]");
    if (oc && $("#cartDrawer")) { e.preventDefault(); openDrawer("#cartDrawer"); return; }
    if (t.closest("[data-open-menu]")) { e.preventDefault(); openDrawer("#mega"); return; }
    if (t.closest("[data-open-search]")) { e.preventDefault(); openSearch(); return; }
    if (t.closest("[data-open-filters]")) { e.preventDefault(); openDrawer("#filterDrawer"); return; }
    var mt = t.closest("[data-mtab]");
    if (mt) {
      $$("[data-mtab]").forEach(function (b) { b.classList.toggle("is-on", b === mt); });
      $$("[data-mpane]").forEach(function (p) { p.classList.toggle("is-on", p.dataset.mpane === mt.dataset.mtab); });
      return;
    }
    var gt = t.closest("[data-gtab]");
    if (gt) { gender(gt.closest("[data-grp]"), gt.dataset.gtab); save("brelo_gender", gt.dataset.gtab); return; }
    var lk = t.closest("[data-look]");
    if (lk) { e.preventDefault(); openLook(lk.dataset.look); return; }
    var fav = t.closest("[data-fav]");
    if (fav) { e.preventDefault(); e.stopPropagation(); toggleFav(fav.dataset.fav); return; }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
  /* Catalogue: the chosen category chip is scrolled into view in the sideways bar (phone) */
  $$(".bar__cats, .facets__row").forEach(function (row) {
    var on = $(".is-on", row);
    if (!on || row.scrollWidth <= row.clientWidth) return;
    var r = row.getBoundingClientRect(), o = on.getBoundingClientRect();
    if (o.right > r.right) row.scrollLeft += o.left - r.left - 24;
  });

  /* Shop by category: კაცი / ქალი tabs. The last gender the visitor browsed opens first. */
  function gender(root, g) {
    if (!root) return;
    $$("[data-gtab]", root).forEach(function (b) { var on = b.dataset.gtab === g; b.classList.toggle("is-on", on); b.setAttribute("aria-selected", on ? "true" : "false"); });
    $$("[data-gpane]", root).forEach(function (p) { p.classList.toggle("is-on", p.dataset.gpane === g); });
  }
  (function () {
    var m = location.pathname.match(/\/collections\/(women|men|grp-|women-grp-)/);
    if (m) save("brelo_gender", m[1].indexOf("women") === 0 ? "women" : "men");
    var g = load("brelo_gender", null);
    if (g) $$("[data-grp]").forEach(function (r) { if ($('[data-gpane="' + g + '"]', r)) gender(r, g); });
  })();


  /* search: predictive results rendered by sections/predictive-search.liquid */
  var sTimer, sCtl, sDefault = null;
  function openSearch() {
    var s = $("#search"); if (!s) return;
    lastFocus = document.activeElement;
    s.classList.add("is-open"); lock(true);
    var body = $("[data-search-results]", s);
    if (sDefault === null) { var tpl = $("#searchDefault"); sDefault = tpl ? tpl.innerHTML : ""; }
    if (!$("input[type=search]", s).value) body.innerHTML = sDefault;
    setTimeout(function () { $("input[type=search]", s).focus(); }, 30);
  }
  function runSearch(q) {
    var body = $("#search [data-search-results]"); if (!body) return;
    if (!q.trim()) { body.innerHTML = sDefault || ""; return; }
    if (sCtl) sCtl.abort();
    sCtl = window.AbortController ? new AbortController() : null;
    var url = B.routes.predictive + "?q=" + encodeURIComponent(q) + "&section_id=predictive-search&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last";
    fetch(url, sCtl ? { signal: sCtl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, "text/html"), res = $("[data-predictive]", d);
      body.innerHTML = res ? res.innerHTML : "";
    }).catch(function () {});
  }
  document.addEventListener("input", function (e) {
    if (e.target.matches && e.target.matches("#search input[type=search]")) { clearTimeout(sTimer); var v = e.target.value; sTimer = setTimeout(function () { runSearch(v); }, 180); }
  });
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-sq]");
    if (!b) return;
    var i = $("#search input[type=search]"); i.value = b.dataset.sq; runSearch(b.dataset.sq);
  });

  /* ---------- header states: sticky bar after the first screen, solid phone header ---------- */
  function headerScroll() {
    var st = $("[data-sticky]"), hdr = $("[data-header]"), mh = $("[data-mhdr]"), home = document.body.classList.contains("is-home");
    var ann = $("[data-ann]");
    function annH() { var h = ann ? ann.offsetHeight : 0; document.documentElement.style.setProperty("--ann-h", h + "px"); return h; }
    var aH = annH(); window.addEventListener("resize", function () { aH = annH(); });
    function on() {
      var y = window.scrollY, bar = $(".bar");
      if (mh && mh.classList.contains("mhdr--over")) mh.style.top = Math.max(0, aH - y) + "px";
      var lim = home ? window.innerHeight * 0.85 : (hdr ? hdr.offsetHeight + 40 : 200), past = y > lim;
      if (st) st.classList.toggle("is-in", past);
      if (bar) bar.classList.toggle("is-stuck", past && window.innerWidth > 860);
      if (mh) mh.classList.toggle("is-solid", y > (home ? window.innerHeight * 0.75 : 4));
    }
    window.addEventListener("scroll", on, { passive: true }); on();
  }

  /* ---------- cart: AJAX add + the drawer re-rendered by the Section Rendering API ---------- */
  function setCount(n) {
    $$(".bagnum").forEach(function (el) { el.textContent = n || ""; el.parentNode.classList.toggle("has-n", !!n); });
  }
  function swapDrawer(html) {
    if (!html) return;
    var d = new DOMParser().parseFromString(html, "text/html"), fresh = $("#cartDrawer", d), cur = $("#cartDrawer");
    if (!fresh || !cur) return;
    var open = cur.classList.contains("is-open");
    cur.innerHTML = fresh.innerHTML;
    if (open) cur.classList.add("is-open");
    var n = fresh.getAttribute("data-count"); setCount(+n || 0);
    codeReminder();
  }
  function addToCart(form, btn) {
    var fd = new FormData(form);
    if (!fd.get("id")) { toast(T.selectSize); return Promise.resolve(); }
    fd.append("sections", "cart-drawer");
    fd.append("sections_url", window.location.pathname);
    if (btn) btn.classList.add("is-busy");
    return fetch(B.routes.cartAdd + ".js", { method: "POST", headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (btn) btn.classList.remove("is-busy");
        if (res.status && res.description) { toast(res.description); return; }
        swapDrawer(res.sections && res.sections["cart-drawer"]);
        toast(T.added);
        if (!form.closest("#lookDrawer")) { closeAll(); openDrawer("#cartDrawer"); }
        else if (btn) { var tx = btn.textContent; btn.textContent = "✓"; setTimeout(function () { btn.textContent = tx; }, 1600); }
      }).catch(function () { if (btn) btn.classList.remove("is-busy"); form.submit(); });
  }
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f.matches && f.matches("form[data-ajax-cart]")) {
      e.preventDefault();
      addToCart(f, e.submitter || $("[type=submit]", f));
    }
  });
  function changeLine(key, qty) {
    return fetch(B.routes.cartChange + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty, sections: "cart-drawer", sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.description) { toast(res.description); return; }
      swapDrawer(res.sections && res.sections["cart-drawer"]);
      if (document.body.classList.contains("t-cart")) window.location.reload();
    });
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-line-key]");
    if (!b) return;
    e.preventDefault();
    changeLine(b.dataset.lineKey, Math.max(0, +b.dataset.qty));
  });

  /* gift wrap and other cart attributes: a checkbox saves itself on the cart */
  document.addEventListener("change", function (e) {
    var c = e.target.closest && e.target.closest("[data-cart-attr]"); if (!c) return;
    var a = {}; a[c.dataset.cartAttr] = c.checked ? "yes" : "";
    fetch(B.routes.cart + "/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ attributes: a }) }).catch(function () {});
  });

  /* ---------- announcement bar: one message at a time, paused while hovered ---------- */
  function announcements() {
    $$("[data-ann]").forEach(function (bar) {
      var msgs = $$(".ann__msg", bar), i = 0, hold = false;
      if (msgs.length < 2 || REDUCED) return;
      bar.addEventListener("mouseenter", function () { hold = true; });
      bar.addEventListener("mouseleave", function () { hold = false; });
      setInterval(function () {
        if (hold || document.hidden) return;
        msgs[i].classList.remove("is-on"); i = (i + 1) % msgs.length; msgs[i].classList.add("is-on");
      }, (+bar.dataset.speed || 5) * 1000);
    });
  }

  /* ---------- first-order offer: shown once, then a small tab; the code is put on the cart right away ---------- */
  function applyCode(code) {
    if (!code) return;
    save("brelo_code", code);
    fetch(B.routes.root.replace(/\/$/, "") + "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(B.routes.cart + ".js")).catch(function () {});
  }
  /* first order: the code goes on the cart once per visit for guests and customers with no paid order (theme.liquid BRELO.firstOrder);
     Shopify checks at checkout that the customer is in the discount's segment */
  function firstOrder() {
    if (!B.firstOrder) return;
    try { if (sessionStorage.getItem("brelo_fo") === B.firstOrder) return; sessionStorage.setItem("brelo_fo", B.firstOrder); } catch (e) {}
    applyCode(B.firstOrder);
  }
  function codeReminder() {
    var code = load("brelo_code", ""), el = $("#cartDrawer [data-wo-reminder]");
    if (!el || !code) return;
    el.textContent = String(T.codeApplied || "").replace("%CODE%", code); el.hidden = false;
  }
  function welcomeOffer() {
    var w = $("[data-wo]"); if (!w) return;
    var KEY = "brelo_wo", state = load(KEY, {}), tab = $("[data-wo-open]"), code = w.dataset.code;
    var ask = $(".wo__ask", w), done = $(".wo__done", w), fired = false;
    function open(claimed) {
      ask.hidden = !!claimed; done.hidden = !claimed;
      lastFocus = document.activeElement; w.classList.add("is-open"); lock(true);
      if (tab) tab.hidden = true;
      var f = claimed ? $("[data-wo-copy]", w) : $("input[type=email]", w); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 80);
    }
    function close() {
      if (!w.classList.contains("is-open")) return;
      w.classList.remove("is-open"); lock(false);
      state.closed = Date.now(); save(KEY, state);
      if (tab && !state.claimed) tab.hidden = false;
    }
    w._close = close;
    w.addEventListener("click", function (e) {
      if (e.target.closest("[data-wo-close]")) { e.preventDefault(); close(); return; }
      if (e.target.closest("[data-wo-copy]")) { if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {}); toast(T.codeCopied); }
    });
    if (tab) tab.addEventListener("click", function () { open(state.claimed); });
    document.addEventListener("click", function (e) { if (e.target.closest("[data-wo-trigger]")) { e.preventDefault(); open(state.claimed); } });
    document.addEventListener("shopify:section:select", function (e) { if (e.target.contains(w)) open(false); });
    document.addEventListener("shopify:section:deselect", function (e) { if (e.target.contains(w)) { w.classList.remove("is-open"); lock(false); } });
    if (w.hasAttribute("data-preview")) return;
    if ($("[data-wo-posted]", w)) { state.claimed = true; save(KEY, state); applyCode(code); open(true); return; }
    if (state.claimed) return;
    if (state.closed && Date.now() - state.closed < (+w.dataset.days || 14) * 864e5) { if (tab) tab.hidden = false; return; }
    function fire() {
      if (fired) return;
      if (document.body.classList.contains("is-locked")) { setTimeout(fire, 4000); return; }
      fired = true; open(false);
    }
    setTimeout(fire, (+w.dataset.delay || 18) * 1000);
    var pct = (+w.dataset.scroll || 45) / 100;
    window.addEventListener("scroll", function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 400 && window.scrollY / max >= pct) fire();
    }, { passive: true });
    if (w.dataset.exit === "true" && window.matchMedia("(hover: hover)").matches)
      document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY <= 0) fire(); });
  }

  /* ---------- favourites + recently viewed (handles in localStorage, cards fetched from the store) ---------- */
  var favs = load("brelo_favs", []), seen = load("brelo_seen", []);
  function syncFavs() {
    $$("[data-fav]").forEach(function (b) { b.classList.toggle("is-on", favs.indexOf(b.dataset.fav) > -1); });
    $$(".favnum").forEach(function (el) { el.textContent = favs.length || ""; el.parentNode.classList.toggle("has-n", !!favs.length); });
  }
  function toggleFav(h) {
    var i = favs.indexOf(h); if (i > -1) favs.splice(i, 1); else favs.unshift(h);
    save("brelo_favs", favs); syncFavs(); toast(i > -1 ? T.removed : T.saved);
  }
  function cardsInto(el, handles) {
    if (!el || !handles.length) return Promise.resolve(0);
    return Promise.all(handles.map(function (h) {
      return fetch(B.routes.root.replace(/\/$/, "") + "/products/" + encodeURIComponent(h) + "?section_id=product-card-ajax")
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (html) { var d = new DOMParser().parseFromString(html, "text/html"), c = $(".card", d); return c ? c.outerHTML : ""; })
        .catch(function () { return ""; });
    })).then(function (cards) {
      var html = cards.filter(Boolean).join("");
      el.innerHTML = html; syncFavs(); return cards.filter(Boolean).length;
    });
  }
  function recentAndSaved() {
    var cur = document.body.dataset.product;
    if (cur) { seen = [cur].concat(seen.filter(function (x) { return x !== cur; })).slice(0, 12); save("brelo_seen", seen); }
    $$("[data-recent]").forEach(function (sec) {
      var list = seen.filter(function (h) { return h !== cur; }).slice(0, +sec.dataset.limit || 8);
      if (!list.length) return;
      cardsInto($("[data-recent-list]", sec), list).then(function (n) { if (n) sec.hidden = false; });
    });
    $$("[data-saved]").forEach(function (sec) {
      var empty = $("[data-saved-empty]", sec);
      if (!favs.length) { if (empty) empty.hidden = false; return; }
      cardsInto($("[data-saved-list]", sec), favs).then(function (n) { if (!n && empty) empty.hidden = false; });
    });
  }

  /* product recommendations: the section re-renders itself through the recommendations endpoint */
  function recommendations() {
    $$("[data-reco]").forEach(function (sec) {
      fetch(sec.dataset.reco).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, "text/html"), list = $("[data-reco-list]", d);
        var box = $("[data-reco-list]", sec), pins = $$("[data-pin]", box);
        if (list && (list.children.length || pins.length)) {
          var seen = pins.map(function (p) { return p.getAttribute("data-pin"); });
          box.innerHTML = "";
          pins.forEach(function (p) { box.appendChild(p); });
          Array.prototype.slice.call(list.children).forEach(function (c) {
            var a = c.querySelector("a[href]"), h = a ? a.getAttribute("href").split("?")[0] : "";
            if (seen.some(function (u) { return h === u; })) return;
            box.appendChild(c);
          });
          syncFavs();
        }
        else sec.hidden = true;
      }).catch(function () { sec.hidden = true; });
    });
  }

  /* ---------- order dates: the steps and the delivery window count from today ---------- */
  function orderDates(root) {
    $$("[data-steps]", root).forEach(function (ol) {
      var from = ol.dataset.from ? new Date(ol.dataset.from) : new Date(), now = new Date();
      $$("li[data-day]", ol).forEach(function (li) {
        var d = new Date(from.getTime() + (+li.dataset.day) * 864e5), out = $("[data-date]", li);
        if (out) out.textContent = fmtDate(d);
        if (ol.dataset.from && now >= d) li.classList.add("is-done");
      });
    });
    $$("[data-delivery-window]", root).forEach(function (el) {
      var a = addDays(14), b = addDays(20); // same window as %ETA% everywhere else: today +14 to +20
      if (KA) el.textContent = a.getMonth() === b.getMonth() ? a.getDate() + "-" + b.getDate() + " " + MONTHS[a.getMonth()] : fmtDate(a) + " - " + fmtDate(b);
      else el.textContent = a.getMonth() === b.getMonth() ? MONTHS[a.getMonth()] + " " + a.getDate() + "-" + b.getDate() : fmtDate(a) + " - " + fmtDate(b);
    });
  }

  /* ---------- order status page: dates from the order date the customer types in ---------- */
  function trackForm() {
    var f = $("[data-track-form]"); if (!f) return;
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = $("input[type=date]", f).value, ol = $("[data-steps]", f.parentNode);
      if (!v || !ol) return;
      ol.dataset.from = v; orderDates(f.parentNode);
      ol.hidden = false;
    });
  }

  /* ---------- product page ---------- */
  function productPage() {
    var root = $("[data-pdp]"); if (!root) return;
    var data = JSON.parse(($("[data-variants]", root) || {}).textContent || "[]");
    var form = $("form[data-product-form]", root), idIn = form && $("input[name=id]", form);
    var addBtn = $("[data-add-main]", root), add2 = $("[data-mbar-add]"), msg = $("[data-msg]", root);
    var priceEl = $("[data-price]", root), cmpEl = $("[data-compare]", root), instEl = $("[data-inst]", root), mbarPrice = $("[data-mbar-price]");
    var groups = $$("[data-opt]", root), notify = $("[data-notify]", root), wa = $("[data-wa]", root), ig = $("[data-ig]", root);
    var months = +(root.dataset.months || 12), base = root.dataset.msg || "";
    var chosen = groups.map(function (g) { var on = $(".is-on", g); return on ? on.dataset.value : null; });

    function find() {
      if (chosen.some(function (v) { return v == null; })) return null;
      return data.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0] || null;
    }
    function waText(v) { return base + (v && v.title && v.title !== "Default Title" ? " · " + T.waSize + ": " + v.title : ""); }
    function paint() {
      // a value is crossed out when no available variant matches it with the other choices
      groups.forEach(function (g, gi) {
        $$("[data-value]", g).forEach(function (b) {
          var ok = data.some(function (v) { return v.available && v.options[gi] === b.dataset.value && v.options.every(function (o, i) { return i === gi || chosen[i] == null || o === chosen[i]; }); });
          b.classList.toggle("is-out", !ok);
          var on = chosen[gi] === b.dataset.value; b.classList.toggle("is-on", on); b.setAttribute("aria-pressed", on);
        });
        var lab = $("[data-opt-value]", g.parentNode); if (lab) lab.textContent = chosen[gi] || "";
      });
      var v = find(), single = data.length === 1;
      if (single && !v) v = data[0];
      if (idIn) idIn.value = v && v.available ? v.id : "";
      if (v) {
        var keep = priceEl && priceEl.dataset.keep ? +priceEl.dataset.keep : 100, shown = Math.floor(v.price * keep / 100);
        if (priceEl) priceEl.textContent = money(shown);
        if (mbarPrice) mbarPrice.textContent = money(shown);
        if (cmpEl) { cmpEl.textContent = keep < 100 ? money(v.price) : v.compare_at_price > v.price ? money(v.compare_at_price) : ""; }
        if (instEl) instEl.textContent = money(Math.ceil(v.price / months / 100) * 100);
        if (window.history.replaceState && !single) { var u = new URL(window.location.href); u.searchParams.set("variant", v.id); window.history.replaceState({}, "", u.toString()); }
      }
      var label = !v ? T.selectSize : v.available ? T.addToCart : T.soldOut;
      [addBtn, add2].forEach(function (b) { if (!b) return; b.textContent = label; b.disabled = !!(v && !v.available) && b === addBtn; });
      if (add2 && v && !v.available) add2.textContent = T.notifyMe || T.soldOut;
      if (notify) {
        notify.hidden = !(v && !v.available);
        var nv = $("[name='contact[variant]']", notify); if (nv && v) nv.value = v.title;
      }
      if (wa) wa.href = "https://wa.me/" + (S.whatsapp || "") + "?text=" + encodeURIComponent(waText(v));
      if (ig) ig.dataset.msg = waText(v);
      if (msg) msg.textContent = "";
      return v;
    }
    groups.forEach(function (g, gi) {
      g.addEventListener("click", function (e) {
        var b = e.target.closest("[data-value]"); if (!b) return;
        chosen[gi] = b.dataset.value; paint();
      });
    });
    function shake() {
      var s = groups[chosen.indexOf(null)] || groups[0];
      if (msg) msg.textContent = T.selectSize;
      if (s) { s.classList.add("is-shake"); setTimeout(function () { s.classList.remove("is-shake"); }, 500); s.scrollIntoView({ behavior: "smooth", block: "center" }); }
    }
    if (form) form.addEventListener("submit", function (e) {
      var v = find() || (data.length === 1 ? data[0] : null);
      if (!v) { e.preventDefault(); e.stopImmediatePropagation(); shake(); }
    }, true);
    if (add2) add2.addEventListener("click", function () {
      var v = find() || (data.length === 1 ? data[0] : null);
      if (v && !v.available && notify) { notify.scrollIntoView({ behavior: "smooth", block: "center" }); var i = $("input[type=email]", notify); if (i) i.focus({ preventScroll: true }); return; }
      if (!v) { shake(); return; }
      if (form.requestSubmit) form.requestSubmit(addBtn); else addToCart(form, addBtn);
    });
    if (ig) ig.addEventListener("click", function () { if (navigator.clipboard) navigator.clipboard.writeText(ig.dataset.msg || base).catch(function () {}); toast(T.msgCopied); });
    paint();

    // sticky buy bar on phones once the main button scrolls away
    var mb = $(".mbar");
    if (mb && addBtn && "IntersectionObserver" in window) new IntersectionObserver(function (en) { mb.classList.toggle("is-in", !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(addBtn);

    // each photo tile takes the colour of the photo's own top-left edge (seamless backdrops across brands)
    $$("img[data-edge]", root).forEach(function (im) {
      function paintEdge() {
        try {
          var c = document.createElement("canvas"); c.width = c.height = 4;
          var x = c.getContext("2d"); x.drawImage(im, 0, 0, 4, 4, 0, 0, 4, 4);
          var d = x.getImageData(0, 0, 1, 1).data;
          if (d[3] > 200) im.parentNode.style.backgroundColor = "rgb(" + d[0] + "," + d[1] + "," + d[2] + ")";
        } catch (e) { /* cross-origin without CORS: keep the default tile */ }
      }
      if (im.complete && im.naturalWidth) paintEdge(); else im.addEventListener("load", paintEdge, { once: true });
    });
    // gallery counter (phone swipe) + full-screen viewer
    var gal = $(".gallery", root), now = $("[data-gnow]", root);
    if (gal && now) {
      var dots = $$(".gdots i", root), thumbs = $$("[data-gthumb]", root);
      gal.addEventListener("scroll", function () {
        var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
        now.textContent = i + 1;
        dots.forEach(function (d, k) { d.classList.toggle("is-on", k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle("is-on", k === i); if (k === i && t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - 16, behavior: "smooth" }); });
      }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener("click", function () { gal.scrollTo({ left: (+t.dataset.gthumb) * gal.clientWidth, behavior: "smooth" }); }); });
    }
    var lb = $(".lb");
    $$("[data-lb]", root).forEach(function (fg) {
      fg.addEventListener("click", function () {
        if (!lb) return;
        var sc = $(".lb__scroll", lb);
        if (!sc.children.length) sc.innerHTML = $$("[data-lb] img", root).map(function (im) { return '<img src="' + esc(im.dataset.full || im.currentSrc || im.src) + '" alt="">'; }).join("");
        lastFocus = document.activeElement; lb.classList.add("is-open"); lock(true);
        var im = sc.children[+fg.dataset.lb]; if (im) setTimeout(function () { im.scrollIntoView(); }, 30);
      });
    });

    $$("[data-copy-link]").forEach(function (b) { b.addEventListener("click", function () { var u = window.location.href; if (navigator.clipboard) navigator.clipboard.writeText(u).then(function () { toast(T.copied); }, function () { toast(u); }); else toast(u); }); });
    $$("[data-sg]", root).forEach(function (b) { b.addEventListener("click", function () { var d = $("#sgAcc"); if (d) { d.open = true; d.scrollIntoView({ behavior: "smooth", block: "center" }); } }); });
    var adv = $("[data-adv]", root);
    if (adv) { adv.hidden = false; adv.addEventListener("click", function () { sizeAdvisor(adv, root.dataset.gender, function (s) { var gi = +(adv.dataset.optIndex || 0); chosen[gi] = s; paint(); }); }); }
  }

  /* size advisor ("find my size"): height + weight, body shape, preferred fit -> a size from this product's own options,
     with the reasons; shoes: usual size or foot length + foot width. Answers are remembered on this device. */
  var ADV = {
    ka: { step: "ნაბიჯი", of: "/", next: "შემდეგი", back: "უკან", calc: "ზომის ნახვა", again: "თავიდან", chart: "ზომების ცხრილი", find: "ზომის შერჩევა",
      h: "სიმაღლე, სმ", w: "წონა, კგ", need: "შეიყვანე სიმაღლე და წონა",
      upW: "მკერდი და მხრები", upM: "მხრები", up: ["ვიწრო", "საშუალო", "განიერი"],
      midW: "თეძოები", midM: "მუცლის არე", mid: ["ბრტყელი", "საშუალო", "სავსე"],
      pref: "როგორ გიყვარს ჩაცმა?", prefs: ["ტანზე მომდგარი", "ჩვეულებრივად", "თავისუფლად"],
      usual: "რა ზომას ატარებ ჩვეულებრივ? (EU)", orLen: "ან ფეხის სიგრძე, სმ", lenHint: "გაზომე ქუსლიდან ყველაზე გრძელ თითამდე",
      width: "ტერფი", widths: ["ვიწრო", "ჩვეულებრივი", "განიერი"], needShoe: "აირჩიე ზომა ან ჩაწერე ფეხის სიგრძე",
      yours: "შენი ზომა", alt: "ორ ზომას შორის ხარ. თუ უფრო თავისუფლად გინდა, აიღე", use: "ამ ზომის არჩევა", out: "ეს ზომა ახლა არ გვაქვს. ყველაზე ახლოს არის",
      rBody: "სიმაღლით და წონით {s} გერგება", rTall: "მაღალი ხარ, ამიტომ ზომას სიგრძის მარაგი სჭირდება", rShort: "დაბალი ხარ, ამიტომ პატარა ზომაც კარგად დაგაჯდება",
      rUpWide: "განიერი მხრების გამო ზედა ნაწილს ადგილი სჭირდება", rMidFull: "წელის არეს თავისუფლება სჭირდება", rSlimShape: "წვრილი აღნაგობის გამო ზომა არ უნდა აჭარბებდეს",
      rTight: "ტანზე მომდგარი გიყვარს", rLoose: "თავისუფლად ჩაცმა გიყვარს",
      rOver: "ეს მოდელი ისედაც ფართოდ იჭრება", rSlimCut: "ეს მოდელი ვიწროდ იჭრება",
      rUsual: "ჩვეულებრივ {s} ზომას ატარებ", rLen: "{l} სმ სიგრძის ფეხს {s} ზომა შეესაბამება", rWide: "განიერი ტერფისთვის ნახევარი ზომით მეტი ჯობია", rUs: "ამ მოდელის ზომები US სისტემაშია",
      note: "საორიენტაციო რჩევაა. ეჭვი თუ გეპარება, მოგვწერე და ზომას ერთად შევარჩევთ." },
    en: { step: "Step", of: "/", next: "Next", back: "Back", calc: "See my size", again: "Start over", chart: "Size chart", find: "Find my size",
      h: "Height, cm", w: "Weight, kg", need: "Enter your height and weight",
      upW: "Bust and shoulders", upM: "Shoulders", up: ["Narrow", "Average", "Broad"],
      midW: "Hips", midM: "Stomach", mid: ["Flat", "Average", "Fuller"],
      pref: "How do you like to wear it?", prefs: ["Close to the body", "Regular", "Relaxed"],
      usual: "What size do you usually wear? (EU)", orLen: "or foot length, cm", lenHint: "Measure from heel to the longest toe",
      width: "Foot width", widths: ["Narrow", "Regular", "Wide"], needShoe: "Pick a size or enter your foot length",
      yours: "Your size", alt: "You are between sizes. For a roomier fit, take", use: "Select this size", out: "This size is not available. The closest is",
      rBody: "Your height and weight point to {s}", rTall: "You are tall, so the size needs some extra length", rShort: "You are on the shorter side, so a smaller size sits well",
      rUpWide: "Broad shoulders need room up top", rMidFull: "The waist area needs a little room", rSlimShape: "With a slim build the size should not run big",
      rTight: "You like a close fit", rLoose: "You like a relaxed fit",
      rOver: "This piece is cut oversized already", rSlimCut: "This piece is cut slim",
      rUsual: "You usually wear {s}", rLen: "A {l} cm foot matches {s}", rWide: "A wide foot is better with half a size up", rUs: "This model is sized in US",
      note: "A guide only. If unsure, message us and we will choose together." }
  };
  var LET = { XXS: 0, XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, "2XL": 6, XXXL: 7, "3XL": 7, "4XL": 8 }, LADDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "3XL", "4XL"];
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || "{}"); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return {}; } }

  /* each option value of this product on the letter scale (clothes) */
  function sizeScale(vals, women) {
    var nums = vals.filter(function (v) { return /^\d+(\.\d+)?$/.test(v) || v === "00"; }).map(function (v) { return v === "00" ? -2 : +v; });
    var min = Math.min.apply(null, nums), max = Math.max.apply(null, nums);
    return vals.map(function (v) {
      var u = v.toUpperCase(), n = v === "00" ? -2 : +v;
      if (LET[u] != null) return LET[u];
      if (isNaN(n)) return null;
      if (max <= 6) return n + 1;                                   // 0..6 (Moncler-style)
      if (women && max <= 16) return n < 0 ? 0 : 1 + n / 4;          // US 00..16
      if (women) return min <= 30 && max <= 34 ? (n - 24) * 0.6 : 1 + (n - 34) / 2;  // jeans waist or EU 34..
      return max <= 40 ? 1 + (n - 28) / 2 : 1 + (n - 44) / 2;        // jeans waist or EU 44..
    });
  }

  function sizeAdvisor(btn, gender, cb) {
    var L = ADV[(document.documentElement.lang || "ka").slice(0, 2)] || ADV.ka, A = JSON.parse(($("#advisorT") || {}).textContent || "{}");
    var women = gender === "women", shoes = btn.dataset.kind === "shoes", fitCut = +btn.dataset.fit || 0;
    var group = $$("[data-opt]")[+(btn.dataset.optIndex || 0)];
    var vals = $$("[data-value]", group).map(function (b) { return b.dataset.value; });
    var outOf = function (v) { var b = $$("[data-value]", group).filter(function (x) { return x.dataset.value === v; })[0]; return b && b.classList.contains("is-out"); };
    var mem = store("brelo_fit"), st = { up: mem.up != null ? mem.up : 1, mid: mem.mid != null ? mem.mid : 1, pref: mem.pref != null ? mem.pref : 1, wid: mem.wid != null ? mem.wid : 1 };
    var chartSrc = $("#sgAcc .acc__body");
    var a = $("#advisor");
    if (!a) { a = document.createElement("div"); a.id = "advisor"; a.className = "modal modal--adv"; document.body.appendChild(a); }
    function opts(id, list, cur) { return '<div class="fopts fopts--eq" id="' + id + '">' + list.map(function (t, i) { return '<button type="button" class="fopt' + (i === cur ? " is-on" : "") + '" data-v="' + i + '">' + esc(t) + "</button>"; }).join("") + "</div>"; }
    function q(t) { return '<p class="adv__q">' + esc(t) + "</p>"; }
    var steps = shoes ? [
      q(L.usual) + '<div class="adv__eu" id="aEu">' + [35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47].map(function (n) { return '<button type="button" class="fopt' + (mem.eu == n ? " is-on" : "") + '" data-v="' + n + '">' + n + "</button>"; }).join("") + "</div>" +
        '<div class="field adv__len"><label for="aLen">' + esc(L.orLen) + '</label><input id="aLen" type="number" inputmode="decimal" step="0.1" placeholder="26.5" value="' + (mem.len || "") + '"><p class="muted">' + esc(L.lenHint) + "</p></div>",
      q(L.width) + opts("aWid", L.widths, st.wid)
    ] : [
      '<div class="row2"><div class="field"><label for="aH">' + esc(L.h) + '</label><input id="aH" type="number" inputmode="numeric" placeholder="178" value="' + (mem.h || "") + '"></div>' +
        '<div class="field"><label for="aW">' + esc(L.w) + '</label><input id="aW" type="number" inputmode="numeric" placeholder="72" value="' + (mem.w || "") + '"></div></div>',
      q(women ? L.upW : L.upM) + opts("aUp", L.up, st.up) + q(women ? L.midW : L.midM) + opts("aMid", L.mid, st.mid),
      q(L.pref) + opts("aPref", L.prefs, st.pref)
    ];
    var tabs = chartSrc ? '<div class="adv__tabs" role="tablist"><button type="button" class="is-on" data-tab="f">' + esc(L.find) + '</button><button type="button" data-tab="c">' + esc(L.chart) + "</button></div>" : "";
    a.innerHTML = '<div class="modal__veil" data-close></div><div class="modal__box" role="dialog" aria-label="' + esc(L.find) + '"><div class="drawer__head"><h2 class="cap">' + esc(L.find) + '</h2><button class="ibtn" data-close aria-label="' + esc(A.close || "") + '">' + (A.icon || "×") + "</button></div>" + tabs +
      '<div class="modal__body"><div id="aFind"><div class="adv__bar"><i></i></div><p class="cap muted adv__n"></p><div id="aStep"></div><p class="adv__err" role="status"></p>' +
      '<div class="adv__nav"><button type="button" class="btn btn--ghost" id="aBack">' + esc(L.back) + '</button><button type="button" class="btn" id="aNext"></button></div></div>' +
      '<div id="aChart" hidden><div class="adv__chart">' + (chartSrc ? chartSrc.innerHTML : "") + "</div></div></div></div>";
    lastFocus = document.activeElement; a.classList.add("is-open"); lock(true);
    $$(".adv__tabs [data-tab]", a).forEach(function (t) { t.onclick = function () { $$(".adv__tabs [data-tab]", a).forEach(function (x) { x.classList.toggle("is-on", x === t); }); $("#aFind").hidden = t.dataset.tab !== "f"; $("#aChart").hidden = t.dataset.tab !== "c"; }; });
    var at = 0;
    function save() {
      var g = function (id) { var on = $("#" + id + " .is-on"); return on ? +on.dataset.v : null; };
      if ($("#aH")) { mem.h = +$("#aH").value || mem.h; mem.w = +$("#aW").value || mem.w; }
      if ($("#aUp")) { st.up = g("aUp"); st.mid = g("aMid"); }
      if ($("#aPref")) st.pref = g("aPref");
      if ($("#aEu")) { mem.eu = g("aEu"); mem.len = +$("#aLen").value || null; }
      if ($("#aWid")) st.wid = g("aWid");
      mem.up = st.up; mem.mid = st.mid; mem.pref = st.pref; mem.wid = st.wid; store("brelo_fit", mem);
    }
    function show(i) {
      at = i; var last = i === steps.length - 1;
      $("#aStep").innerHTML = steps[i]; $(".adv__err", a).textContent = "";
      $(".adv__n", a).textContent = L.step + " " + (i + 1) + " " + L.of + " " + steps.length;
      $(".adv__bar i", a).style.width = ((i + 1) / steps.length * 100) + "%";
      $("#aBack").style.visibility = i ? "visible" : "hidden"; $("#aNext").textContent = last ? L.calc : L.next;
      $$("#aStep .fopts, #aStep .adv__eu").forEach(function (g) { $$(".fopt", g).forEach(function (b) { b.onclick = function () { $$(".fopt", g).forEach(function (x) { x.classList.toggle("is-on", x === b); }); if (g.id === "aEu") $("#aLen").value = ""; }; }); });
      var inp = $("#aStep input"); if (inp && !inp.value) setTimeout(function () { inp.focus(); }, 60);
    }
    $("#aBack").onclick = function () { save(); show(at - 1); };
    $("#aNext").onclick = function () {
      save();
      if (!shoes && at === 0 && (!mem.h || !mem.w || mem.h < 120 || mem.w < 30)) { $(".adv__err", a).textContent = L.need; return; }
      if (shoes && at === 0 && !mem.eu && !mem.len) { $(".adv__err", a).textContent = L.needShoe; return; }
      if (at < steps.length - 1) return show(at + 1);
      result();
    };
    function pickNearest(score, scale) {
      var best = null, bd = 1e9;
      vals.forEach(function (v, i) { if (scale[i] == null) return; var d = Math.abs(scale[i] - score) + (outOf(v) ? 0.001 : 0); if (d < bd) { bd = d; best = v; } });
      return best;
    }
    function result() {
      var why = [], want, alt = null;
      var fill = function (s, o) { return s.replace(/\{(\w)\}/g, function (_, k) { return o[k]; }); };
      if (shoes) {
        var eu = mem.len ? Math.round(1.5 * (mem.len + 1.5) * 2) / 2 : mem.eu;
        why.push(mem.len ? fill(L.rLen, { l: mem.len, s: eu }) : fill(L.rUsual, { s: eu }));
        if (st.wid === 2) { eu += 0.5; why.push(L.rWide); }
        var nums = vals.map(Number), us = Math.max.apply(null, nums.filter(isFinite)) <= 16;
        var target = us ? (women ? eu - 30.5 : eu * 0.787 - 24.1) : eu;
        if (us) why.push(L.rUs);
        var up = vals.filter(function (v) { return +v >= target - 0.01; }).sort(function (x, y) { return x - y; });
        want = up[0] || vals[vals.length - 1];
        var avail = up.filter(function (v) { return !outOf(v); })[0];
        if (outOf(want) && avail) alt = avail;
      } else {
        var bmi = mem.w / Math.pow(mem.h / 100, 2);
        var s = women ? 2 + (bmi - 21) / 2.8 : 3 + (bmi - 24.5) / 3, base = Math.round(Math.max(0, Math.min(8, s)));
        why.push(fill(L.rBody, { s: LADDER[base] }));
        var hd = (mem.h - (women ? 167 : 180)) / 12; s += hd;
        if (hd > 0.4) why.push(L.rTall); else if (hd < -0.4) why.push(L.rShort);
        s += [-0.3, 0, 0.4][st.up] + [-0.2, 0, 0.5][st.mid];
        if (st.up === 2) why.push(L.rUpWide); if (st.mid === 2) why.push(L.rMidFull); if (st.up === 0 && st.mid === 0) why.push(L.rSlimShape);
        s += [-0.5, 0, 0.8][st.pref];
        if (st.pref === 0) why.push(L.rTight); if (st.pref === 2) why.push(L.rLoose);
        if (fitCut >= 4 && st.pref !== 2) { s -= (fitCut - 3) * 0.3; why.push(L.rOver); }
        if (fitCut && fitCut <= 2) { s += (3 - fitCut) * 0.3; why.push(L.rSlimCut); }
        var scale = sizeScale(vals, women);
        want = pickNearest(s, scale);
        var fr = s - Math.floor(s);
        if (fr > 0.35 && fr < 0.65) { var hi = pickNearest(Math.ceil(s), scale); if (hi !== want) alt = hi; }
      }
      var avail = !outOf(want), html = '<div class="adv__res"><p class="cap muted">' + esc(L.yours) + '</p><p class="advisor__size">' + esc(want) + "</p>";
      if (!avail) html += '<p class="adv__alt">' + esc(L.out) + " <b>" + esc(alt || "") + "</b></p>";
      else if (alt) html += '<p class="adv__alt">' + esc(L.alt) + " <b>" + esc(alt) + "</b></p>";
      html += '<ul class="adv__why">' + why.map(function (w) { return "<li>" + esc(w) + "</li>"; }).join("") + "</ul>";
      var take = avail ? want : alt;
      html += (take ? '<button type="button" class="btn" id="aUse">' + esc(L.use) + " · " + esc(take) + "</button>" : "") +
        '<button type="button" class="linkbtn adv__again" id="aAgain">' + esc(L.again) + '</button><p class="muted adv__note">' + esc(L.note) + "</p></div>";
      $("#aStep").innerHTML = html; $(".adv__nav", a).hidden = true; $(".adv__n", a).textContent = ""; $(".adv__bar i", a).style.width = "100%";
      if (take) $("#aUse").onclick = function () { closeAll(); cb(take); };
      $("#aAgain").onclick = function () { $(".adv__nav", a).hidden = false; show(0); };
    }
    show(0);
  }

  /* ---------- shop the look: each look is a <template> rendered server-side with its own size selects ---------- */
  function openLook(id) {
    var tpl = document.getElementById("look-" + id), d = $("#lookDrawer");
    if (!tpl || !d) return;
    $(".look", d).innerHTML = "";
    $(".look", d).appendChild(tpl.content.cloneNode(true));
    syncFavs(); openDrawer(d);
  }

  /* ---------- catalogue: grid columns ---------- */
  function catalogue() {
    var g = $("[data-grid]"); if (!g) return;
    var cols = load("brelo_cols", +(g.dataset.default || 4));
    if (PHONE && cols > 4) cols = 4;   /* phone: "4" shows two columns, "2" one big card */
    function set(n) {
      cols = n; save("brelo_cols", n);
      g.dataset.cols = n; g.style.setProperty("--cols", n);
      $$("[data-cols]").forEach(function (b) { b.classList.toggle("is-on", +b.dataset.cols === n); });
    }
    $$("[data-cols]").forEach(function (b) { b.addEventListener("click", function () { set(+b.dataset.cols); }); });
    set(cols);
    // filter drawer: live count from the Section Rendering API after each change
    var ff = $("[data-filter-form]");
    if (ff) {
      var apply = $("[data-filter-apply]", ff), tmr;
      ff.addEventListener("change", function () {
        clearTimeout(tmr);
        tmr = setTimeout(function () {
          var q = new URLSearchParams(new FormData(ff)).toString(), sid = ff.dataset.section;
          fetch(window.location.pathname + "?" + q + "&section_id=" + sid).then(function (r) { return r.text(); }).then(function (html) {
            var d = new DOMParser().parseFromString(html, "text/html"), c = $("[data-count]", d);
            if (apply && c) apply.textContent = apply.dataset.label + " (" + c.dataset.count + ")";
          }).catch(function () {});
        }, 200);
      });
    }
  }

  /* ---------- brand films: muted loops that load and play only while on screen ---------- */
  var vidIO = null;
  function videos(root) {
    var vs = $$("video.vid", root); if (!vs.length || REDUCED) return;
    if (!vidIO) vidIO = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio > 0.25) {
          if (!v.getAttribute("src") && v.dataset.src) v.src = PHONE && v.dataset.srcM ? v.dataset.srcM : v.dataset.src;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.25, 0.6] });
    vs.forEach(function (v) { vidIO.observe(v); });
  }

  /* ---------- motion: reveal, parallax, giant wordmark, counters (native scrolling, one rAF loop) ---------- */
  function reveal(root) {
    var els = $$(".rv, .rvc", root);
    if (!("IntersectionObserver" in window) || REDUCED) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } }); }, { rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (e) { io.observe(e); });
  }
  var SUBS = [];
  function scrollEngine() {
    var last = -1, vh = window.innerHeight, dirty = true;
    window.addEventListener("resize", function () { vh = window.innerHeight; dirty = true; });
    (function frame() {
      var y = window.scrollY;
      if (y !== last || dirty) { last = y; dirty = false; for (var i = 0; i < SUBS.length; i++) SUBS[i](y, vh); }
      requestAnimationFrame(frame);
    })();
  }
  function motion() {
    if (REDUCED) return;
    var par = $$("[data-par]");
    if (par.length) SUBS.push(function (y, vh) {
      for (var i = 0; i < par.length; i++) {
        var el = par[i], box = el.parentNode.getBoundingClientRect();
        if (box.bottom < -100 || box.top > vh + 100) continue;
        var d = (box.top + box.height / 2 - vh / 2) / vh;
        el.style.transform = "translate3d(0," + (d * -60 * (+el.dataset.par)) + "px,0) scale(1.04)";
      }
    });
    var giant = $(".hero__giant");
    if (giant) SUBS.push(function (y, vh) {
      if (y > vh * 1.2) return;
      giant.style.transform = "translate3d(0," + (y * -0.28) + "px,0)";
      giant.style.opacity = String(Math.max(0, 1 - y / (vh * 0.75)));
    });
    var counts = $$("[data-count-to]");
    if (counts.length) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return; io.unobserve(e.target);
          var c = e.target, to = +c.dataset.countTo, t0 = performance.now();
          (function tick(now) { var q = clamp01((now - t0) / 1400); c.textContent = Math.round(to * (1 - Math.pow(1 - q, 3))); if (q < 1) requestAnimationFrame(tick); })(t0);
        });
      }, { rootMargin: "0px 0px -20% 0px" });
      counts.forEach(function (c) { io.observe(c); });
    }
  }

  /* ---------- the film: a flipbook that plays by itself; a touch stops it, a sideways drag browses,
     and it resumes only after the section has left the screen ---------- */
  function films() {
    $$(".flip").forEach(function (flip) {
      var imgs = $$(".flip__frame img", flip); if (!imgs.length) return;
      var flash = $(".flip__flash", flip), count = $(".flip__count b", flip), prog = $(".flip__prog i", flip), state = $(".flip__state", flip);
      var marks = $$("[data-mark]", flip), link = $(".flip__brand", flip), n = imgs.length, cur = 0;
      var STEP = +(flip.dataset.speed || 400), PX = window.matchMedia("(pointer: coarse)").matches ? 14 : 18;
      function n2(i) { return (i < 9 ? "0" : "") + (i + 1); }
      function setFrame(i, fl) {
        i = ((i % n) + n) % n; if (i === cur) return;
        imgs[cur].classList.remove("is-on"); imgs[i].classList.add("is-on");
        if (fl && flash && i % 4 === 0 && !REDUCED) { flash.classList.remove("is-go"); void flash.offsetWidth; flash.classList.add("is-go"); }
        var mk = imgs[i].dataset.mark;
        marks.forEach(function (m) { m.hidden = m.dataset.mark !== mk; });
        if (link && imgs[i].dataset.href) link.href = imgs[i].dataset.href;
        cur = i; if (count) count.textContent = n2(i);
        if (prog) prog.style.transform = "scaleX(" + ((i + 1) / n) + ")";
      }
      var playing = false, held = false, timer = null, startX = 0, startF = 0, dragging = false, moved = false;
      function setState() { if (state) state.textContent = held ? (T.paused || "") : ""; flip.classList.toggle("is-held", held); }
      function play() { if (playing || held || REDUCED) return; playing = true; timer = setInterval(function () { setFrame(cur + 1, true); }, STEP); }
      function stop() { playing = false; clearInterval(timer); }
      function hold() { held = true; stop(); setState(); }
      new IntersectionObserver(function (en) {
        var e = en[0];
        if (e.isIntersecting && e.intersectionRatio > 0.35) play();
        else { stop(); if (!e.isIntersecting) { held = false; setState(); } }
      }, { threshold: [0, 0.35, 0.6] }).observe(flip);
      var area = $(".flip__frame", flip);
      area.addEventListener("pointerdown", function (e) { hold(); dragging = true; moved = false; startX = e.clientX; startF = cur; try { area.setPointerCapture(e.pointerId); } catch (x) {} });
      area.addEventListener("pointermove", function (e) { if (!dragging) return; var dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; setFrame(startF - Math.round(dx / PX), false); });
      function end() { dragging = false; }
      area.addEventListener("pointerup", end); area.addEventListener("pointercancel", end);
      area.addEventListener("click", function (e) { if (moved) e.preventDefault(); });
      flip.addEventListener("wheel", function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 2) { e.preventDefault(); hold(); setFrame(cur + (e.deltaX > 0 ? 1 : -1), false); }
      }, { passive: false });
      flip.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") { e.preventDefault(); hold(); setFrame(cur + (e.key === "ArrowRight" ? 1 : -1), false); }
        if (e.key === " ") { e.preventDefault(); if (held) { held = false; setState(); play(); } else hold(); }
      });
      if (prog) prog.style.transform = "scaleX(" + (1 / n) + ")";
    });
  }

  /* ---------- brand wall: the campaign photo follows the cursor (desktop) ---------- */
  function brandWall() {
    if (!window.matchMedia("(hover: hover)").matches) return;
    $$(".brandwall").forEach(function (wall) {
      var prev = $(".bprev", wall); if (!prev) return;
      $$("[data-prev]", wall).forEach(function (a) {
        a.addEventListener("mouseenter", function () { if (!a.dataset.prev) return; $("img", prev).src = a.dataset.prev; prev.classList.add("is-on"); wall.classList.add("is-hovering"); a.classList.add("is-hot"); });
        a.addEventListener("mouseleave", function () { prev.classList.remove("is-on"); wall.classList.remove("is-hovering"); a.classList.remove("is-hot"); });
      });
      wall.addEventListener("mousemove", function (e) { var r = wall.getBoundingClientRect(); prev.style.transform = "translate(" + (e.clientX - r.left + 24) + "px," + (e.clientY - r.top - 140) + "px)"; });
    });
  }

  /* ---------- theme editor: re-run the section scripts when a section is added or changed ---------- */
  document.addEventListener("shopify:section:load", function (e) { reveal(e.target); videos(e.target); orderDates(e.target); films(); syncFavs(); $$(".rv, .rvc", e.target).forEach(function (x) { x.classList.add("is-in"); }); });
  document.addEventListener("shopify:block:select", function (e) { var mp = e.target.closest && e.target.closest(".mega"); if (mp) openDrawer(mp); });

  function init() {
    headerScroll(); announcements(); welcomeOffer(); firstOrder(); codeReminder(); syncFavs(); recentAndSaved(); recommendations(); orderDates(document); trackForm();
    productPage(); catalogue(); videos(document); reveal(document); motion(); films(); brandWall(); scrollEngine();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

/* desktop category panel */
(function () {
  var drop = document.querySelector("[data-drop]");
  if (!drop) return;
  var t;
  function open(nav) {
    clearTimeout(t);
    var box = nav.closest("[data-header],[data-sticky]") || nav;
    drop.style.top = Math.max(0, box.getBoundingClientRect().bottom) + "px";
    drop.classList.add("is-open");
  }
  function close() { clearTimeout(t); t = setTimeout(function () { drop.classList.remove("is-open"); }, 180); }
  document.querySelectorAll("[data-drop-trigger]").forEach(function (nav) {
    nav.addEventListener("mouseenter", function () { open(nav); });
    nav.addEventListener("mouseleave", close);
    nav.addEventListener("focusin", function () { open(nav); });
  });
  drop.addEventListener("mouseenter", function () { clearTimeout(t); });
  drop.addEventListener("mouseleave", close);
  drop.addEventListener("focusout", function (e) { if (!drop.contains(e.relatedTarget)) close(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") drop.classList.remove("is-open"); });
  window.addEventListener("scroll", function () { if (drop.classList.contains("is-open")) drop.classList.remove("is-open"); }, { passive: true });
})();

/* welcome-offer tab: out of the way while scrolling, back a moment after the page stops.
   Home: it also waits until the first screen is half scrolled, so it never covers the giant BRELO logo. */
(function () {
  var t, home = document.body.classList.contains("is-home");
  function hero() { var tab = document.querySelector(".wo-tab"); if (tab) tab.classList.toggle("is-hero", home && window.scrollY < window.innerHeight * 0.5); }
  window.addEventListener("scroll", function () {
    var tab = document.querySelector(".wo-tab");
    if (!tab) return;
    tab.classList.add("is-away");
    clearTimeout(t);
    t = setTimeout(function () { tab.classList.remove("is-away"); }, 1200);
    hero();
  }, { passive: true });
  hero();
})();
